import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import {
  BuscaTramite,
  BuscaTramiteInput,
  SolicitudEtapaTramites,
  Solicitudes,
  AuxJasper,
  ParametroJasper,
  InfoTramiteInput,
  InfoTramite,
  CancelaSolicitudInput,
  CatUsuarios,
  MonitoreoFlujoTramite,
  MonitoreoFlujoTramiteInput
} from "../../entidades/entidades";

import { JasperService } from "../../servicios/jasper.service";
import { BuscaTramiteService } from "../../servicios/busca-tramite.service";
import { CancelaSolicitudService } from "../../servicios/cancela-solicitud.service";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { InfoTramiteService } from "../../servicios/info-tramite.service";
import { AuthenticationService } from 'app/servicios';
import { WebdriverWebElement } from "protractor/built/element";
import {ConfirmationService, MessageService} from 'primeng/api';

declare var $: any;

@Component({
  selector: "app-info-tramite",
  templateUrl: "./info-tramite.component.html",
  styleUrls: ["./info-tramite.component.css"],
})
export class InfoTramiteComponent implements OnInit {
  private _jasperService: JasperService;
  public auxJasper: AuxJasper;
  public solicitudes = new Solicitudes();

  public tramite: BuscaTramite;
  public infoTramite = new InfoTramite();
  public cancelaSolicitudInput = new CancelaSolicitudInput();
  public usuario: any;
  public monitoreoFlujoTramiteInput = new MonitoreoFlujoTramiteInput();
  public monitoreoFlujoTramite = new MonitoreoFlujoTramite();
  public Mostrar: boolean = false;
  infoTramiteForm: FormGroup;
  motivoCancelacion: string = "";
  mostrarDialogoCancelacion: boolean = false;
  muestraMensaje = new MuestraMensaje();

  @Input("infoTramiteInput") infoTramiteInput: InfoTramiteInput;
  @Output("infoTramiteOutput") infoTramiteOutput: EventEmitter<InfoTramite>;
  @Input("canceltramite") canceltramite: boolean = false;

  buscaTramiteTable: InfoTramite[];

  display: boolean = false;
  display2: boolean = false;
  buscando: boolean = false;
  

  showDialog() {
    this.display = true;
  }



  public tableWidget: any;
  public idSoli: number;

  constructor(
    private buscaTramiteService: BuscaTramiteService,
    private infoTramiteService: InfoTramiteService,
    private formBuilder: FormBuilder,
    private cancelaSolicitudService: CancelaSolicitudService,
    private authenticationService: AuthenticationService,
    private solicitudesService: SolicitudesService,
    private confirmationService: ConfirmationService,
     private messageService: MessageService,
  ) {
    this.infoTramiteOutput = new EventEmitter();
    this.infoTramiteForm = new FormGroup({
      id: new FormControl(),
      numSolicitud: new FormControl(),
      cuentaAgua: new FormControl(),
      fecha: new FormControl(),
      solicitante: new FormControl(),
      estadoTramite: new FormControl(),
      concepto: new FormControl(),
      estatusPago: new FormControl(),
      observaciones: new FormControl(),
      domicilio: new FormControl(),
      idconcepto: new FormControl(),
      idEstadoTramite: new FormControl(),
      idEstatus: new FormControl(),
      rutaPagina: new FormControl(),
    });
  }

  async ngOnInit() {
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;
    
    this.infoTramiteForm = this.formBuilder.group({
      id: [undefined],
      numSolicitud: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cuentaAgua: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      fecha: [undefined],
      solicitante: [undefined],
      estadoTramite: [undefined],
      concepto: [undefined],
      estatusPago: [undefined],
      observaciones: [undefined],
      domicilio: [undefined],
      idconcepto: [undefined],
      idEstadoTramite: [undefined],
      idEstatus: [undefined],
      rutaPagina: [undefined],
    });
    // if(this.infoTramiteInput)
    // {

    //   this.getBuscaTramite(this.infoTramiteInput);
    //   //if (this.infoTramite) this.infoTramiteForm.patchValue(this.infoTramite);
    // }

    // if (this.infoTramiteInput) {
    //   this.getBuscaTramite(this.infoTramiteInput);
    //   console.log("ngOnChanges info-tramite", this.infoTramiteInput);
    // }
  }
  ngOnChanges() {
    if (this.infoTramiteInput) {
      this.getBuscaTramite(this.infoTramiteInput);
    }
  }
  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================

  async getBuscaTramite(infoTramite: InfoTramiteInput) {
    try {
      const datoRetorno = await this.infoTramiteService
        .getBusquedas(infoTramite)
        .toPromise();
      this.infoTramite = datoRetorno;

      if (this.infoTramite[0] != null) {
        let aux = this.infoTramite[0].fecha;
        let fecha = aux.substring(0, 10);
        let fechaSeparada = fecha.split('-');
        let fechaFinal = fechaSeparada[2] + '-' + fechaSeparada[1] + '-' + fechaSeparada[0];
        this.infoTramite[0].fecha = fechaFinal;


        this.infoTramiteForm.patchValue(this.infoTramite[0]);

        this.idSoli = datoRetorno[0].id;
      } else {

        this.infoTramiteForm.patchValue({
          id: null,
          numSolicitud: null,
          cuentaAgua: null,
          fecha: null,
          solicitante: null,
          estadoTramite: null,
          concepto: null,
          estatusPago: null,
          observaciones: null,
          domicilio: null,
          idconcepto: null,
          idEstadoTramite: null,
          idEstatus: null,
          rutaPagina: null,
        });
      }

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getBuscaTramite");
    }
  }

  async getAllBuscaTramite() {
    try {
      const datoRetorno = await this.buscaTramiteService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllBuscaTramite");
    }
  }
  async limpia() {
    try {
      (document.getElementById("myForm") as HTMLFormElement).reset();
      this.tramite = new BuscaTramite();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }
  async imprimir() {
    try {
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "Solicitud";
      this.auxJasper.JasperReport.tipo = "pdf";
      let parametroJasper = new ParametroJasper();
      parametroJasper.nombre = "_id_solicitud";
      parametroJasper.valor = this.idSoli + "";
      await this.auxJasper.ParametroJasper.push(parametroJasper);
      let parametroJasperFl = new ParametroJasper();
      parametroJasperFl.nombre = "par_seguimiento_t";
      parametroJasperFl.valor = "true";
      await this.auxJasper.ParametroJasper.push(parametroJasperFl);

      await this.showDialog();
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }

  async cancelar() {
    if(this.buscando){
      return;
    }
    try{
      if (!this.motivoCancelacion.trim()) {
          this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe ingresar un motivo de cancelación' });
          return;
      }
      //Valida el estatus de la solicitud 
      const datoRetorno = await this.solicitudesService.getSingle(this.idSoli).toPromise();
      this.solicitudes = datoRetorno;

      if(this.solicitudes.idEstatus == 4){
        this.muestraMensaje.warning("La solicitud ya se encuentra cancelada.", "top", "center");
        return;
      }
      if(this.solicitudes.idEstatus == 2){
        this.muestraMensaje.warning("La solicitud no se puede cancelar por que ya se encuentra pagada", "top", "center");
        return;
      }
      if(this.solicitudes.idEstatus == 5){
        this.muestraMensaje.warning("La solicitud no se puede cancelar por que ya se encuentra Terminada", "top", "center");
        return;
      }
      this.cancelaSolicitudInput.idSolicitud = this.idSoli;
      this.cancelaSolicitudInput.idUsuarioCancelo = this.usuario.id;
      this.cancelaSolicitudInput.observaciones = this.motivoCancelacion;

      this.buscando = true;
      await this.getCancelaSolicitudes(this.cancelaSolicitudInput);

      //EMITE AL PADRE
      let newInfoTramite = new InfoTramite();
      newInfoTramite.id = this.idSoli;
      
      this.infoTramiteOutput.emit(newInfoTramite);

    } catch (e){
      this.muestraMensaje.error(e.message, "top", "Center");
      if(e.response) throw { message: e.response.data};
      else throw e;
    } finally {
      this.mostrarDialogoCancelacion = false; // Cerrar diálogo
      this.buscando = false;
      this.motivoCancelacion = "";
      console.log("Paso por Cancelar Solicitudes");
      
    }
  }
  async getCancelaSolicitudes( cancelaSolicitudInput: CancelaSolicitudInput   ) {
    try {
      const datoRetorno = await this.cancelaSolicitudService
        .getBusquedas(cancelaSolicitudInput)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.muestraMensaje.notification(
        "Proceso Concluido (Cancelar).",
        "top",
        "center"
      );
      console.log("Paso por  getCancelaSolicitudes");
    }
  } 
}
